// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__39Uv7","calendarButtons":"ClockData_calendarButtons__2Iucy"};